import * as fromActionsOpenEnded from '../actions/answer-open-ended.action'
import * as fromActionsLikert from '../actions/answer-likert.action'
import * as fromActionsTask from '../actions/answer-task.action'

import { Reducer } from 'redux'

export const initialState: any = {
  requestState: false,
  ids: [],
}

export const reducer: Reducer<any> = (state: any = initialState, { type, payload }) => {
  switch (type) {
    case fromActionsOpenEnded.ANSWER_OPEN_ENDED_CREATE:
      return {
        ...state,
        requestState: false,
      }
    case fromActionsOpenEnded.ANSWER_OPEN_ENDED_CREATE_SUCCESS:
      return {
        ...state,
        requestState: true,
      }
    case fromActionsLikert.ANSWER_LIKERT_CREATE:
      return {
        ...state,
        requestState: false,
      }
    case fromActionsLikert.ANSWER_LIKERT_CREATE_SUCCESS:
      return {
        ...state,
        requestState: true,
      }
    case fromActionsTask.ANSWER_TASK_CREATE_SUCCESS:
      return {
        ...state,
        ids: payload,
        requestState: true,
      }
    case fromActionsTask.ANSWER_TASK_CREATE:
      return {
        ...state,
        requestState: false,
      }
    default:
      return state
  }
}
